$(".img-parallax").each(function () {
  var img = $(this);
  var imgParent = $(this).parent();
  function parallaxImg() {
    var speed = img.data("speed");
    var imgY = imgParent.offset().top;
    var winY = $(this).scrollTop();
    var winH = $(this).height();
    var parentH = imgParent.innerHeight();

    // The next pixel to show on screen
    var winBottom = winY + winH;

    // If block is shown on screen
    if (winBottom > imgY && winY < imgY + parentH) {
      // Number of pixels shown after block appear
      var imgBottom = (winBottom - imgY) * speed;
      // Max number of pixels until block disappear
      var imgTop = winH + parentH;
      // Porcentage between start showing until disappearing
      var imgPercent = (imgBottom / imgTop) * 100 + (50 - speed * 50);
    }
    img.css({
      top: imgPercent + "%",
      transform: "translate(-50%, -" + imgPercent + "%)",
    });
  }
  $(document).on({
    scroll: function () {
      parallaxImg();
    },
    ready: function () {
      parallaxImg();
    },
  });
});
$(document).ready(function () {
  // Function to handle the fade-in effect
  function fadeInOnScroll() {
    $(".text-effect").each(function () {
      var $text = $(this);
      var textTop = $text.offset().top;
      var textHeight = $text.outerHeight();
      var winTop = $(window).scrollTop();
      var winHeight = $(window).height();

      // Calculate the bottom position of the viewport
      var winBottom = winTop + winHeight;

      // Check if the element is within the viewport
      if (winBottom > textTop && winTop < textTop + textHeight) {
        // Apply the fade-in effect
        $text.css("opacity", 1);
      } else {
        // Keep it hidden when out of view
        $text.css("opacity", 0);
      }
    });
  }

  // Call fadeInOnScroll on scroll and resize
  $(window).on("scroll", function () {
    fadeInOnScroll();
  });
  $(window).on("resize", function () {
    fadeInOnScroll(); // Recalculate on resize
  });

  // Initial call to set the correct state on page load
  fadeInOnScroll();

  // home page customer review
  var swiper = new Swiper(".review-slider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  if ($(window).width() < 768) {
    var swiper = new Swiper(".cacao-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination1",
      },
    });
  }
  jQuery(".f-popup__content .f-popup__cta .btn").prop("href", "#");
  jQuery(".f-popup__content .f-popup__cta .btn")
    .off("click")
    .on("click", function (e) {
      console.log("sdfsdfsdf");
      e.preventDefault();
      jQuery(".f-popup__content form#ContactSubscribe-Popup").submit();
    });
});
$(window).scroll(function () {
  var scrollTop = $(this).scrollTop(); // Use $(this) to refer to the window
  var windowHeight = $(window).height(); // Define window height

  $(".bg-chocolate").each(function () {
    var elementTop = $(this).offset().top; // Get the top position of the current section

    // Check if the user has scrolled past this element
    if (scrollTop > elementTop - windowHeight) {
      $(this).find(".image-with-text__media").addClass("fadeInRight");
    } else {
      $(this).find(".image-with-text__media").removeClass("fadeInRight");
    }
  });
  $(".bg-darkbrown").each(function () {
    var elementTop = $(this).offset().top; // Get the top position of the current section

    // Check if the user has scrolled past this element
    if (scrollTop > elementTop - windowHeight) {
      $(this).find(".image-with-text__media").addClass("fadeInLeft");
    } else {
      $(this).find(".image-with-text__media").removeClass("fadeInLeft");
    }
  });
});
function Timeline(selector, config) {
  this.el = $(selector);

  // options do not effect CSS, has to be set seperately
  const defaults = {
    track: {
      endAtLast: false,
    },
    viewPointBottom: true,
    viewPoint: 100,
  };
  this.options = $.extend({}, defaults, config || {});

  $(document).ready(() => {
    this.init();
  });

  this.init = function () {
    this.el.addClass("is-loading");
    this.el.addClass("is-init");
    this.el.each(function () {
      this.offsetHeight;
    });
    this.el.removeClass("is-loading");
    this.animation();
    this.trackHeight();

    let self = this;
    $(document).scroll(function () {
      self.animation();
    });
    $(document).resize(function () {
      self.trackHeight();
    });
  };

  this.animation = function () {
    let self = this;

    let scrollTop = $(document).scrollTop();
    let viewPoint = scrollTop + this.options.viewPoint;
    if (this.options.viewPointBottom) {
      viewPoint = scrollTop + window.innerHeight - this.options.viewPoint;
    }

    this.updateTrack(viewPoint);

    $(".timeline__item", this.el).each(function (i, v) {
      let top = $(this).offset().top;
      let bottom = $(this).offset().top + $(this).outerHeight(true);

      if (viewPoint < top) {
        self.updateClasses(this, "is-below");
      } else if (viewPoint > bottom) {
        self.updateClasses(this, "is-above is-visible");
      } else {
        self.updateClasses(this, "is-current is-visible");
      }
    });

    if ($(".timeline__footer").length) {
      let footer = ".timeline__footer";
      let top = $(footer).offset().top;

      if (viewPoint < top) {
        self.updateClasses(footer, "");
      } else {
        self.updateClasses(footer, "is-visible");
      }
    }
  };

  this.updateClasses = function (el, newClass) {
    $(el).removeClass("is-above is-current is-below is-visible");
    $(el).addClass(newClass);
  };

  this.updateTrack = function (viewPoint) {
    $el = $(".timeline__track", ".timeline");
    let top = $el.offset().top;
    let height = viewPoint - top;
    $el.height(height);
  };

  this.trackHeight = function () {
    let trackMax = this.el.outerHeight();
    if ($(".timeline__footer").length) {
      trackMax -= $(".timeline__footer").outerHeight();
    }
    if (this.options.track.endAtLast) {
      trackMax = trackMax - $(".timeline__item").last().outerHeight() + 9;
    }
    $(".timeline__track", this.el).css("max-height", trackMax);
  };
}

new Timeline(".timeline");
